// extracted by mini-css-extract-plugin
export var rateTable = "_5d-0";